import { CmsContent } from '@domgen/dgx-fe-cms';

export type CmsErrorPage = CmsContent;
